import React from "react";
var __jsx = React.createElement;
import Markdown from "markdown-to-jsx";
import stl from "../../StaticPage.module.css";
import BreadCrumb from "@componentsShared/BreadCrumb";
import { useTranslation } from "@i18n";
import useIsWebView from "@hooks/useIsWebview";
var ReturnPolicy = function ReturnPolicy(_ref) {
  var title = _ref.title,
    published_date = _ref.published_date,
    content = _ref.content,
    _ref$hideBreadCrumb = _ref.hideBreadCrumb,
    hideBreadCrumb = _ref$hideBreadCrumb === void 0 ? false : _ref$hideBreadCrumb;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;
  var isWebView = useIsWebView();
  var showBreadCrumb = !hideBreadCrumb && !isWebView;
  return /*#__PURE__*/React.createElement("section", {
    className: stl.Content
  }, showBreadCrumb && /*#__PURE__*/React.createElement(BreadCrumb, {
    className: "mt-1 ms-0",
    links: [{
      title: tShort("return_policy")
    }]
  }), content && /*#__PURE__*/React.createElement(Markdown, null, content));
};
export default ReturnPolicy;